const passwordPolicyValidator = (password) => {
  return {
    hasLowercase: hasLowercase(password),
    hasUppercase: hasUppercase(password),
    hasNumber: hasNumber(password),
    hasSpecial: hasSpecial(password),
    hasMinLength: hasMinLength(password)
  }
}

const passwordSatisfiesPolicy = (password) => {
  const passwordPolicyState = passwordPolicyValidator(password)
  return passwordPolicyState.hasLowercase && passwordPolicyState.hasUppercase && 
    passwordPolicyState.hasNumber && passwordPolicyState.hasSpecial && passwordPolicyState.hasMinLength
}

const hasLowercase = (password) => {
  return !!password.match(/[a-z]/)
}

const hasUppercase = (password) => {
  return !!password.match(/[A-Z]/)
}

const hasNumber = (password) => {
  return !!password.match(/\d/)
}

const hasSpecial = (password) => {
  return !!password.match(/(?![a-zA-Z0-9])[!-~]/)
}

const hasMinLength = (password) => {
  return password.length >= 8
}

export {
  passwordPolicyValidator,
  passwordSatisfiesPolicy,
}


// WEBPACK FOOTER //
// ./src/utils/passwordPolicyValidator.js